import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

// 在 .env 文件中配置: REACT_APP_GOOGLE_CLIENT_ID=你的ClientID
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID';

function GoogleLoginButton({ onError }) {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const buttonRef = useRef(null);

  useEffect(() => {
    // 判断是否手机/触屏设备，手机端弹窗常被 COOP/浏览器内嵌拦截，改用 redirect 模式
    const isMobile = typeof window !== 'undefined' && (
      /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (window.matchMedia && window.matchMedia('(max-width: 768px)').matches)
    );

    // 服务器 redirect 回调地址（手机端使用）
    const apiBase = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
    const loginUri = apiBase.startsWith('http')
      ? `${apiBase}/auth/google/redirect`
      : `${window.location.origin}${apiBase}/auth/google/redirect`;

    // 等待 Google GSI 脚本加载
    const initGoogleSignIn = () => {
      if (!window.google?.accounts?.id) {
        setTimeout(initGoogleSignIn, 200);
        return;
      }

      const initConfig = {
        client_id: GOOGLE_CLIENT_ID,
        auto_select: false,
      };
      if (isMobile) {
        // 手机端：redirect 模式，Google 会 POST 凭证到 login_uri
        initConfig.ux_mode = 'redirect';
        initConfig.login_uri = loginUri;
      } else {
        // 桌面端：popup 模式 + 回调
        initConfig.ux_mode = 'popup';
        initConfig.callback = handleCredentialResponse;
      }
      window.google.accounts.id.initialize(initConfig);

      if (buttonRef.current) {
        // width 最大 400，手机端给固定宽度避免 offsetWidth=0 时按钮渲染异常
        const containerWidth = buttonRef.current.offsetWidth;
        const width = Math.min(Math.max(containerWidth || 320, 240), 400);
        window.google.accounts.id.renderButton(buttonRef.current, {
          theme: 'outline',
          size: 'large',
          width,
          text: 'signin_with',
          shape: 'rectangular',
          locale: 'zh_CN',
        });
      }
    };

    initGoogleSignIn();
  }, []);

  const handleCredentialResponse = async (response) => {
    try {
      await loginWithGoogle(response.credential);
      navigate('/');
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Google 登录失败';
      if (onError) onError(errorMsg);
    }
  };

  return (
    <div>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12,
        margin: '20px 0', color: 'var(--text-light)', fontSize: '0.85rem',
      }}>
        <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
        <span>或</span>
        <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
      </div>

      <div ref={buttonRef} style={{ display: 'flex', justifyContent: 'center' }} />

      {GOOGLE_CLIENT_ID === 'YOUR_GOOGLE_CLIENT_ID' && (
        <p style={{
          fontSize: '0.75rem', color: 'var(--text-light)', textAlign: 'center',
          marginTop: 8, lineHeight: 1.5,
        }}>
          Google 登录需配置 Client ID，请参考 README 说明
        </p>
      )}
    </div>
  );
}

export default GoogleLoginButton;
